import React from 'react'
import {findDOMNode} from 'react-dom'
import NavigationMenu_ProjectsTree from "./tree/projects-tree"
import NavigationMenu_ProjectsTags from "../tags/tags"
import NavigationMenu_ProjectsLocalSettings from "../../local-settings"
import NavigationMenu_TopHeader from "../../components/top-header/top-header"
import NavigationMenu_SpacePreferences from "../../components/space-preferences/preferences"
import NavigationMenuProjectsViewsV2 from "./views/views-v2"
import {EVENT_BUS_MENU_SORT_CHANGED, EVENT_BUS_MENU_SORT_RESET, MenuComponentProps} from "../const"
import VScroll from "../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import {
    BUS_TREE_CHANGE,
    BUS_USER_CHANGE, SESSION_COMPANY_SETTINGS_CHANGED,
    SESSION_PROJECT_CHANGE,
    SESSION_STARRED_CHANGED
} from "../../../../core/gd/bus/bus-event-type"
import {MenuSpaceSearch} from "../../components/search/menu-space-search"
import {SpaceProjects} from "../../../../core/model2/space/system/projects"
import MenuTopHeader_SearchActive from "../../components/top-header/search/search"
import MenuSearch_Results from "../../../search/search-results/menu-search-results"
import NavigationMenuSection from "../../menu-items/section/section"
import MenuTopHeader_SearchButton from "../../components/top-header/search/search-button"
import NavigationMenu_StarredProjects from "../../components/starred/starred-projects"
import {ProjectsTreeSortType} from "../../../../core/model2/space/@types";
import spacePreferences_PopoverMenuOptions from "../../actions/space-preferences-menu-options";
import NavigationMenu_ProjectsContent from "./menu-content";

// const debug = "MenuProjects"
const debug = false

export default class NavigationMenu_Projects extends React.Component<MenuComponentProps,any> {

    private animationDelay  : any
    private animShow        : boolean = false

    public localSettings    : NavigationMenu_ProjectsLocalSettings
    public spaceSearch      : MenuSpaceSearch

    constructor(props:MenuComponentProps) {
        super(props)

        this.localSettings  = new NavigationMenu_ProjectsLocalSettings()
        this.spaceSearch    = new MenuSpaceSearch(new SpaceProjects(), this.reRender)

    }

    componentDidMount() {
        // // gd.router.on('route', this.onRoute);
        // gd.bus.subscribe(BUS_TREE_CHANGE, this, this.onTreeChange)
        // gd.bus.subscribe(SESSION_COMPANY_SETTINGS_CHANGED, this, this.onCompanySettingsChange)
        // gd.bus.subscribe(BUS_USER_CHANGE, this, this.onUserSettingsChange)
        //
        // // need it on this level as we separate stars and all projects
        // gd.bus.subscribe(SESSION_STARRED_CHANGED, this, this.onSessionStarredChanged)
        // gd.bus.subscribe(EVENT_BUS_MENU_SORT_CHANGED, this, this.onSortTypeChange)
        // gd.bus.subscribe(EVENT_BUS_MENU_SORT_RESET, this, this.onSortDefaultReset)
        // gd.bus.subscribe(SESSION_PROJECT_CHANGE, this, this.sessionProjectChanged)

        this.animationDelay = _.delay(()=>{
            this.animShow = true
            const dom = findDOMNode(this)
            gd.utils.Dom.addClass(dom, 'anim-show')
        }, 50)
    }

    componentWillUnmount() {
        clearTimeout(this.animationDelay)
        gd.bus.unsubscribe(this)
    }

    onTreeChange = () => {
        debug && console.log(debug, 'onTreeChange')

        this.forceUpdate()
    }

    // onCompanySettingsChange = () => {
    //     debug && console.log(debug, 'onCompanySettingsChange')
    //
    //     this.forceUpdate()
    // }

    onUserSettingsChange = () => {
        debug && console.log(debug, 'onUserSettingsChange')

        this.forceUpdate()
    }

    onSessionStarredChanged = () => {
        debug && console.log(debug, 'onSessionStarredChanged')

        this.forceUpdate()
    }

    onSortTypeChange = (value:ProjectsTreeSortType) => {
        debug && console.log(debug, 'onSortTypeChange', value)

        this.localSettings.sortType = value
        this.localSettings.save()

        this.forceUpdate()
    }

    onSortDefaultReset = () => {
        debug && console.log(debug, 'onSortDefaultReset')
        gd.user.menu.projectsAll.sortedMap = {}
        gd.user.menu.save()

        this.forceUpdate()
    }

    // sessionProjectChanged = (projectId: ID) => {
    //     if (gd.spaces.projects.id === gd.session.projects.get(projectId)?.space.id) {
    //         this.forceUpdate()
    //     }
    // }

    async expandParentsForProject(projectId:ID) {
        return new Promise((resolve, reject) => {
            const parentProjectsIds = gd.session.projects.getAllParents(projectId).map((p:any)=>p.id)
            this.localSettings.expandedProjects = _.union(this.localSettings.expandedProjects, parentProjectsIds)
            this.localSettings.save()

            this.forceUpdate(()=>{
                resolve(true)
            })
        })
    }

    reRender = ()=> {
        this.forceUpdate()
    }

    render() {

        const rootTags = gd.session.projects.rootTags

        debug && console.log(debug, 'render rootTags=', rootTags)

        const classes = Classes('main-menu-container ui5-menu menu-projects',{
            'animation'     : gd.layout.shouldAnimateMenu && !this.props.noAnimation,
            'anim-show'     : this.animShow
        });

        const rightButtonsClasses = Classes("flex-row-right-center", {
            "w-100-percent": this.spaceSearch.isActive
        })

        const isSearchEnabled   = this.spaceSearch.enabled

        const controls = (
            <NavigationMenu_SpacePreferences className      = "m-r-5"
                                             space          = {gd.spaces.projects}
                                             localSettings  = {this.localSettings}
                                             onReset        = {this.reRender}/>
        )

        return (
            <div className={classes}>

                {!this.spaceSearch.isActive &&
                    <NavigationMenu_TopHeader space = {gd.spaces.projects}>
                        <div className={rightButtonsClasses}>
                            <MenuTopHeader_SearchButton className  = "m-r-15" spaceSearch   = {this.spaceSearch}/>
                        </div>
                    </NavigationMenu_TopHeader>
                }

                {this.spaceSearch.isActive &&
                    <div className="top-header flex-row-between-center">
                        <MenuTopHeader_SearchActive spaceSearch   = {this.spaceSearch}/>
                    </div>
                }


                <VScroll ref={this.props.refScroll} className="main-menu-scroll" mutationObserverEnabled={true}>

                    {isSearchEnabled &&
                        <MenuSearch_Results space={gd.spaces.projects} searchResult={this.spaceSearch.searchResults} />
                    }

                    {!isSearchEnabled &&

                        <NavigationMenu_ProjectsContent {...this.props} />
                        // <>
                        //     <NavigationMenu_StarredProjects space={gd.spaces.projects} />
                        //
                        //     <NavigationMenuSection name         = "Resources"
                        //                            collapsible  = {true}
                        //                            menuOptions  = {spacePreferences_PopoverMenuOptions(gd.spaces.projects, this.localSettings, this.reRender)}
                        //                            controls     = {controls}
                        //                            systemName   = "projects-resources"
                        //                            counter      = {gd.spaces.projects.menuResourcesCounter}>
                        //
                        //         <NavigationMenu_ProjectsTree localSettings  = {this.localSettings}
                        //                                      space          = {gd.spaces.projects} />
                        //
                        //     </NavigationMenuSection>
                        //
                        //     {rootTags?.length > 0 &&
                        //         <NavigationMenu_ProjectsTags showAdd = {true}
                        //                                      tags    = {rootTags}/>
                        //     }
                        //
                        //     <NavigationMenuProjectsViewsV2 />
                        // </>
                    }

                </VScroll>

            </div>
        )
    }
}
